var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAdult = function SvgAdult(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 23",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.783 5.415c1.077 0 2.063.718 2.43 1.772l1.558 4.433c.16.431 0 .958-.367 1.198a1 1 0 0 1-.504.143c-.367 0-.733-.263-.87-.646L7.997 9.368v12.386c0 .671-.55 1.198-1.192 1.126-.573-.048-.985-.575-.985-1.174v-7.235c0-.192-.138-.336-.321-.336l-.066.007a.32.32 0 0 0-.255.329v7.283c0 .671-.55 1.198-1.192 1.126-.572-.048-.985-.575-.985-1.174V9.368L1.97 12.315a.906.906 0 0 1-1.192.575c-.481-.168-.733-.743-.55-1.246l1.559-4.457c.39-1.078 1.352-1.772 2.429-1.772zM5.4.122c1.239-.058 2.289.956 2.345 2.265.056 1.308-.903 2.416-2.142 2.474s-2.289-.955-2.345-2.264S4.16.18 5.399.122z"
  })));
};
export default SvgAdult;